import { render, staticRenderFns } from "./AmsSelectTable.vue?vue&type=template&id=ec377150&"
import script from "./AmsSelectTable.vue?vue&type=script&lang=js&"
export * from "./AmsSelectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports